module.exports = __webpack_public_path__ + "img/967-43c24c.png";